import { useAppDispatch, useAppState } from '@/store';
import { useEffect } from 'react';
import {
  getAiBotSettings,
  selectAiBotSettings,
  selectAiBotSettingsError,
  selectAiBotSettingsIsLoading,
} from '../feature';

export const useGetAiBotSettings = ({ channelSlug }: { channelSlug?: string }) => {
  const isLoading = useAppState(selectAiBotSettingsIsLoading);
  const settings = useAppState(selectAiBotSettings);
  const error = useAppState(selectAiBotSettingsError);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!channelSlug) return;
    dispatch(getAiBotSettings({ channelSlug }));
  }, [channelSlug, dispatch]);

  return {
    isLoading,
    settings,
    error,
  };
};
